export const getApiRoot = () => {
  let base = '/'
  return base;
};

let _auth = {}
export let auth = {
  get() {
    return _auth;
  },
  set(value) {
    _auth = value;
  },
};

export const getApiParam = () => {
  let param = {auth: auth.get()};
  return param;
};

export const getRoot = () => {
  let base = "/";
  return base;
};

export const IMAGE_PATH = "/img/";
